import axios from 'axios';
import LocalidadTabla from '../types/LocalidadTabla';

async function InsertarLocalidad(LocalidadNueva: LocalidadTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_localidad"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "localidad": [
                {
                    "codpostal": LocalidadNueva.codpostal,
                    "localidad": LocalidadNueva.localidad,
                    "habilitado": LocalidadNueva.habilitado,
                    "id_pais": LocalidadNueva.pais_id,
                    "id_provincia": LocalidadNueva.provincia_id
                }
            ]
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarLocalidad;